<template>
    <div class="t-lk-modal__content _middle">
        <h2 class="t-lk-modal__title">{{ $root.staticText.lk.inviteTitle }}</h2>

        <form
            class="t-form t-lk-modal__form t-lk-modal-edit__form"
            @submit.stop.prevent="submitForm()"
        >
            <div class="t-feedback__content">
                <div v-for="(item, index) in cmpForm" class="t-feedback__item">
                    <div v-if="item.title" class="t-form__label">
                        {{ item.title }}
                        <span v-if="item.requiredField">*</span>
                    </div>

                    <input
                        v-if="item.type === 'text'"
                        class="t-input"
                        :class="{ _error: item.error, _valid: item.valid }"
                        :type="item.type"
                        :placeholder="item.hintField"
                        v-model="item.value"
                        @focus="focusForm(index)"
                    />
                </div>
            </div>

            <vue-recaptcha
                ref="recaptcha"
                size="invisible"
                :sitekey="$root.sitekeyRecaptcha"
                :load-recaptcha-script="true"
                @verify="onCapchaRegister"
                @expired="onCaptchaExpired"
                @error="errorCaptcha"
            />
            <button
                class="t-btn _lk _green t-lk-modal-edit__btn"
                :class="{ _disabled: infoForm.disabledBtn }"
            >
                {{ $root.staticText.lk.inviteBtn }}
            </button>
        </form>
    </div>
</template>

<script>
    import {mapActions} from "vuex";
    import Vue from "vue";
    import VueRecaptcha from "vue-recaptcha";

    export default {
        name: "invite",
        props: ['props'],
        data() {
            return {
                recaptchaToken: null,
                isValid: false,
                infoForm: {
                    action: "lk/invite",
                    disabledBtn: false,
                },
                cmpForm: [
                    {
                        title: this.$root.staticText.forms.email,
                        id: 'email',
                        type: 'text',
                        value: '',
                        hintField: this.$root.staticText.forms.placeholderEmail,
                        error: false,
                        valid: false,
                        requiredField: true,
                        pattern: /^[+a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/i
                    }
                ]
            }
        },
        components: {
            VueRecaptcha,
        },
        methods: {
            ...mapActions('modal', ['modalType_inviteSuccessOpen', 'modalType_lkErrorOpen', 'modalClose']),

            onCapchaRegister(recaptchaToken) {
                this.recaptchaToken = recaptchaToken;
                if (this.isValid) {
                    this.sendForm();
                }
            },
            onCaptchaExpired() {
                this.$refs.recaptcha.reset();
            },
            errorCaptcha() {
                console.log('errorCaptcha');
            },

            validate() {
                let is_valid = true;

                for (let i = 0; i < this.cmpForm.length; i++) {
                    this.cmpForm[i].error = false;
                    if (
                        this.cmpForm[i].pattern !== '' &&
                        (!this.cmpForm[i].requiredField ? this.cmpForm[i].value !== '' : true)
                    ) {
                        this.cmpForm[i].valid = true;
                        if (!this.cmpForm[i].pattern.test(this.cmpForm[i].value.trimEnd())) {
                            this.cmpForm[i].error = true;
                            this.cmpForm[i].valid = false;
                            is_valid = false;
                        }
                    }
                }
                this.isValid = is_valid;
            },
            submitForm() {
                this.validate();

                if (this.isValid) {
                    this.$refs.recaptcha.execute();
                }
            },
            sendForm() {
                this.infoForm.disabledBtn = true;
                let fd = new FormData();
                fd.append('recaptchaToken', this.recaptchaToken);
                fd.append('idEvent', this.props.id);

                for (let i = 0; i < this.cmpForm.length; i++) {
                    fd.append(this.cmpForm[i].id, this.cmpForm[i].value.toString().trimEnd());
                }

                Vue.http.post(this.infoForm.action, fd)
                    .then(response => response.json())
                    .then(data => {
                        this.infoForm.disabledBtn = false;
                        if (data.success) {
                            this.modalClose();
                            this.modalType_inviteSuccessOpen({
                                email: this.cmpForm[0].value,
                                closeBthNone: true
                            });

                        } else {
                            this.openError(data);
                        }
                    })
                    .catch(data => {
                        this.infoForm.disabledBtn = false;
                        this.openError(data);
                    });
            },
            focusForm(i) {
                this.cmpForm[i].error = false;
            },
            openError(data) {
                let text = this.$root.staticText.lk.lkErrorText;
                if (data.errors && data.errors.length > 0) {
                    let key = Object.keys(data.errors)[0];
                    if (data.errors[key][0]) {
                        text = data.errors[key][0];
                    }
                }
                this.modalType_lkErrorOpen({
                    title: this.$root.staticText.lk.lkErrorTitle,
                    text: text,
                    closeBthNone: true
                });
            },
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/invite.vue